const gtagEventName = {
  register: "register",
};
export const gtagEventRegister = (email, uuid) => {
  window.dataLayer.push({
    event: gtagEventName.register,
    email: email,
    eui: uuid,
  });
};
